/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import Imgix from 'js/components/Imgix';
import { FormattedMessage } from 'js/lib/coursera.react-intl';

import { Typography2, breakpoints } from '@coursera/cds-core';

import _t from 'i18n!nls/front-page';

type Props = {
  authorName?: string | null;
  text?: string | null;
  imageUrl?: string | null;
};

const styles = {
  container: () => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    ${breakpoints.up('sm')} {
      flex-direction: row;
      align-items: start;
      gap: 16px;
    }
  `,
  image: () => css`
    flex-shrink: 0;
    position: relative;
    width: 136px;
    height: 136px;
    ${breakpoints.up('sm')} {
      width: 80px;
      height: 80px;
    }

    overflow: hidden;
    border-radius: 100%;

    > img {
      position: absolute;
      height: 100%;
      left: 50%;
      transform: translateX(-50%);
    }
  `,
  text: () => css`
    text-align: center;
    ${breakpoints.up('sm')} {
      text-align: unset;
    }
  `,
  authorName: () => css`
    margin-top: var(--cds-spacing-150);
  `,
};

const Testimonial = ({ authorName, text, imageUrl }: Props) => {
  if (!text || !authorName) {
    return null;
  }
  return (
    <div css={styles.container}>
      {imageUrl && (
        <div css={styles.image}>
          <Imgix alt="" src={imageUrl} maxHeight={136} />
        </div>
      )}
      <div>
        <Typography2 variant="bodyPrimary" color="supportText" component="div" css={styles.text}>
          <FormattedMessage message={_t('"{text}"')} text={text} />
          <div css={styles.authorName}>&ndash; {authorName}</div>
        </Typography2>
      </div>
    </div>
  );
};

export default Testimonial;
